import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateChatChatIdMessageMessageIdReactionsLayoutRoute() {
  return <ModalStack />;
}
